module.exports = __webpack_public_path__ + "img/fav.1a861701.svg";